export default "__VITE_ASSET__CIJUdzAx__"